import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { forumApi } from '../../api/forum';
import { formatRelativeTime } from '../../utils/relativeTime';
import HrnbLoader from '../controls/HrnbLoader';
import '../../css/components/PopularPosts.css';

/**
 * Виджет «Недавно активные» в сайдбаре форума.
 * Показывает посты с самыми свежими комментариями/обновлениями.
 * Сортировка по updatedAt (DESC).
 */
export default function RecentActivePosts({ limit = 3 }) {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRecentActive();
    }, []);

    const fetchRecentActive = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await forumApi.listPosts({
                page: 0,
                size: limit,
                sortBy: 'updatedAt',
                direction: 'DESC',
            });
            const allPosts = data.content || data.posts || data || [];
            setPosts(allPosts.slice(0, limit));
        } catch (err) {
            console.warn('[RecentActivePosts] Failed to fetch:', err.message);
            setError('Не удалось загрузить');
            setPosts([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="popular-posts">
                <h5 className="popular-posts-title">Недавно активные</h5>
                <div className="popular-posts-loading"><HrnbLoader size="sm" /></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="popular-posts">
                <h5 className="popular-posts-title">Недавно активные</h5>
                <div className="sidebar-widget-error">
                    <span className="sidebar-widget-error-text">{error}</span>
                    <button className="sidebar-widget-retry" onClick={fetchRecentActive}>↻ Повторить</button>
                </div>
            </div>
        );
    }

    if (posts.length === 0) return null;

    return (
        <div className="popular-posts">
            <h5 className="popular-posts-title">Недавно активные</h5>
            <div className="popular-posts-list">
                {posts.map((post, index) => {
                    const authorName = post.author
                        ? (typeof post.author === 'string' ? post.author : (post.author.displayName || post.author.username || ''))
                        : '';
                    const activeDate = post.updatedAt || post.createdAt;
                    return (
                        <div
                            key={post.id}
                            className="popular-posts-item"
                            onClick={() => {
                                try {
                                    sessionStorage.setItem('hrnb_forum_from_forum', 'true');
                                } catch (e) { /* ignore */ }
                                navigate(`/forum/posts/${post.id}`);
                            }}
                        >
                            <span className="popular-posts-rank">{index + 1}</span>
                            <div className="popular-posts-item-body">
                                <span className="popular-posts-item-title">{post.title}</span>
                                <span className="popular-posts-item-meta">
                                    {authorName && <span>{authorName}</span>}
                                    <span>{formatRelativeTime(activeDate)}</span>
                                </span>
                                <span className="popular-posts-item-stats">
                                    💬 {post.commentCount ?? post.commentsCount ?? post.comments ?? 0}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
